import {Moment} from 'moment';
import * as moment from 'moment';
import {PodValidationDeliveryItem} from './pod-validation-delivery-item.model';



export class PodValidation {

  public id: string;
  public deliveryNumber: string;
  public salesOrderNumber: string;
  public loadNumber: string;
  public documentId: string;
  public documentSource: DocumentSource;
  public carrierId: string;
  public mrFinalQuantity: number;
  public carrierName: string;
  public state: PodState;
  public rejected: boolean;
  public rejectReason: string;
  public deliveryDate: Moment;
  public validationDate: Moment;
  public submissionDate: Moment;
  public type: PodValidationDeliveryType;

  public deliveryItems: PodValidationDeliveryItem[] = [];


  public originGlid: string;
  public originName: string;
  public destinationGlid: string;
  public destinationName: string;

  public static fromDto(pv): PodValidation {
    if (!pv) {
      return null;
    }

    const podValidation = new PodValidation();
    podValidation.id = pv.id;
    podValidation.deliveryNumber = pv.deliveryNumber;
    podValidation.salesOrderNumber = pv.salesOrderNumber;
    podValidation.loadNumber = pv.loadNumber;
    podValidation.documentId = pv.documentId;
    podValidation.documentSource = pv.documentSource;
    podValidation.carrierId = pv.carrierId;
    podValidation.carrierName = pv.carrierName;
    podValidation.state = pv.state;
    podValidation.rejected = pv.rejected;
    podValidation.rejectReason = pv.rejectReason;
    podValidation.deliveryDate = pv.deliveryDate ? moment(pv.deliveryDate) : null;
    podValidation.validationDate = pv.validationDate ? moment(pv.validationDate) : null;
    podValidation.submissionDate = pv.submissionDate ? moment(pv.submissionDate) : null;
    podValidation.type = pv.type;
    podValidation.mrFinalQuantity = pv.mrFinalQuantity;
    podValidation.originGlid = pv.shipFromLocationCode;
    podValidation.originName = pv.shipFromLocationName;
    podValidation.destinationGlid = pv.shipToLocationCode;
    podValidation.destinationName = pv.shipToLocationName;

    podValidation.deliveryItems = pv.deliveryItems ?  pv.deliveryItems.map(PodValidationDeliveryItem.fromDto) : [];

    return podValidation;
  }
}

export enum PodState {
  PENDING = 'PENDING',
  CHEP_REVIEW = 'CHEP_REVIEW',
  VALIDATED = 'VALIDATED',
}

export enum PodSearchMode {
  REJECTED = 'REJECTED',
  DELIVERY_TODAY = 'DELIVERY_TODAY',
  DEFAULT = 'DEFAULT',
  DELIVERY_LESS_THAN_ONE_WEEK = 'DELIVERY_LESS_THAN_ONE_WEEK',
  DELIVERY_MORE_THAN_ONE_WEEK = 'DELIVERY_MORE_THAN_ONE_WEEK',
}

export enum PodValidationDeliveryType {
  MANUFACTURER = 'MANUFACTURER',
  MR = 'MR',
}

export enum DocumentSource {
  CMAWEB_API = 'CMAWEB_API',
  CMA_API = 'CMA_API',
  CARRIER_API = 'CARRIER_API',
}

export class TabResultCount {
  pendingTotalCount: number;
  chepReviewTotalCount: number;
  validatedTotalCount: number;
  totalCount: number;

  constructor(pendingTotalCount: number, chepReviewTotalCount: number, validatedTotalCount: number) {
    this.pendingTotalCount = pendingTotalCount;
    this.chepReviewTotalCount = chepReviewTotalCount;
    this.validatedTotalCount = validatedTotalCount;
    this.totalCount = (pendingTotalCount || 0) + (chepReviewTotalCount || 0) + (validatedTotalCount || 0);
  }
}
